import React from 'react';
// import PropTypes from 'prop-types';
// import _ from 'lodash';
// import moment from 'moment';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
// import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import Typography from '@material-ui/core/Typography';
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import messages from './messages';

// const userShape = PropTypes.shape({
//   _id: PropTypes.string.isRequired,
//   firstName: PropTypes.string.isRequired,
//   lastName: PropTypes.string.isRequired,
// }).isRequired;
//
// const lessonShape = PropTypes.shape({
//   name: PropTypes.string.isRequired,
// }).isRequired;

@injectIntl
export default class ConfirmDeleteDescription extends React.PureComponent {
  static propTypes = {
    // courseRelations: PropTypes.shape({
    //   favoriteCourses: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       _id: PropTypes.string.isRequired,
    //       userId: userShape,
    //     }),
    //   ).isRequired,
    //   discussions: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       _id: PropTypes.string.isRequired,
    //       name: PropTypes.string.isRequired,
    //     }),
    //   ).isRequired,
    //   userCourses: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       _id: PropTypes.string.isRequired,
    //       userId: userShape,
    //     }),
    //   ).isRequired,
    //   videoNotes: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       _id: PropTypes.string.isRequired,
    //       userId: userShape,
    //       lessonId: lessonShape,
    //     }),
    //   ).isRequired,
    //   textNotes: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       _id: PropTypes.string.isRequired,
    //       userId: userShape,
    //       lessonId: lessonShape,
    //     }),
    //   ).isRequired,
    //   tasks: PropTypes.arrayOf(
    //     PropTypes.shape({
    //       _id: PropTypes.string.isRequired,
    //       users: PropTypes.arrayOf(userShape).isRequired,
    //       name: PropTypes.string.isRequired,
    //     }),
    //   ).isRequired,
    // }).isRequired,
    intl: intlShape.isRequired,
  };

  render() {
    // const { courseRelations } = this.props;

    // const favoriteCourses = _.get(courseRelations, 'favoriteCourses', []);
    // const discussions = _.get(courseRelations, 'discussions', []);
    // const userCourses = _.get(courseRelations, 'userCourses', []);
    // const videoNotes = _.get(courseRelations, 'videoNotes', []);
    // const textNotes = _.get(courseRelations, 'textNotes', []);
    // const tasks = _.get(courseRelations, 'tasks', []);

    return (
      <div>
        <Typography variant="subtitle1" color="secondary" paragraph>
          <FormattedMessage {...messages.description} />
        </Typography>
        {/* {!!favoriteCourses.length && (
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                <FormattedMessage
                  {...messages.favoriteCourses}
                  values={{ count: favoriteCourses.length }}
                />
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <ul>
                {_.map(favoriteCourses, ({ _id, userId }) => (
                  <li key={_id}>
                    <Typography>
                      {_.get(userId, 'firstName', '')}{' '}
                      {_.get(userId, 'lastName', '')}
                    </Typography>
                  </li>
                ))}
              </ul>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )}
        {!!discussions.length && (
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                <FormattedMessage
                  {...messages.discussions}
                  values={{ count: discussions.length }}
                />
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <ul>
                {_.map(discussions, ({ _id, name, latestResponseDate }) => (
                  <li key={_id}>
                    <Typography>
                      {name}{' '}
                      {latestResponseDate &&
                        moment(latestResponseDate).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                  </li>
                ))}
              </ul>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )}
        {!!userCourses.length && (
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <div>
                <Typography variant="body1">
                  <FormattedMessage
                    {...messages.userCourses}
                    values={{ count: userCourses.length }}
                  />
                </Typography>
                <Typography variant="body1" color="inherit">
                  <FormattedMessage {...messages.userCoursesSubtitle} />
                </Typography>
              </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <ul>
                {_.map(userCourses, ({ _id, userId }) => (
                  <li key={_id}>
                    <Typography>
                      {_.get(userId, 'firstName', '')}{' '}
                      {_.get(userId, 'lastName', '')}
                    </Typography>
                  </li>
                ))}
              </ul>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )}
        {!!videoNotes.length && (
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                <FormattedMessage
                  {...messages.videoNotes}
                  values={{ count: videoNotes.length }}
                />
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <ul>
                {_.map(videoNotes, ({ _id, lessonId, userId }) => (
                  <li key={_id}>
                    <Typography>
                      {_.get(userId, 'firstName', '')}{' '}
                      {_.get(userId, 'lastName', '')} ({_.get(
                        lessonId,
                        'name',
                        '',
                      )})
                    </Typography>
                  </li>
                ))}
              </ul>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )}
        {!!textNotes.length && (
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                <FormattedMessage
                  {...messages.textNotes}
                  values={{ count: textNotes.length }}
                />
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <ul>
                {_.map(textNotes, ({ _id, lessonId, userId }) => (
                  <li key={_id}>
                    <Typography>
                      {_.get(userId, 'firstName', '')}{' '}
                      {_.get(userId, 'lastName', '')} ({_.get(
                        lessonId,
                        'name',
                        '',
                      )})
                    </Typography>
                  </li>
                ))}
              </ul>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )}
        {!!tasks.length && (
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="body1">
                <FormattedMessage
                  {...messages.tasks}
                  values={{ count: tasks.length }}
                />
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              {_.map(tasks, ({ _id, name, startDate, endDate, users }) => (
                <ExpansionPanel key={_id}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <div>
                      <Typography variant="body1" paragraph>
                        {name} ({moment(startDate).format('DD/MM/YYYY HH:mm')} -{' '}
                        {moment(endDate).format('DD/MM/YYYY HH:mm')})
                      </Typography>
                      <Typography paragraph>
                        <FormattedMessage
                          {...messages.assignees}
                          values={{ count: users.length }}
                        />
                      </Typography>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <ul>
                      {_.map(users, ({ userId }) => (
                        <li key={_.get(userId, '_id', '')}>
                          <Typography>
                            {_.get(userId, 'firstName', '')}{' '}
                            {_.get(userId, 'lastName', '')}
                          </Typography>
                        </li>
                      ))}
                    </ul>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        )} */}
      </div>
    );
  }
}
